import { Box } from '@mui/material'; // Import Box for layout
import { EmailAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { auth } from "../../firebase/firebase";
import { HelpTextComponent } from "../base/helpText/HelpTextComponent";
import { Loading } from "../base/loading/Loading";
import { AnimatedBox, SpeedDurations } from '../MotionMui/MotionMui'; // Adjust path if needed
import './SignIn.css'; // Keep for existing Firebase UI styles or other base styles
import StyledFirebaseAuth from './StyledFirebaseAuth';

// --- FirebaseUI config ---
const uiConfig = {
    signInFlow: 'popup',
    signInSuccessUrl: '/teams/',
    signInOptions: [
        EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD,
        GoogleAuthProvider.PROVIDER_ID,
    ],
};

// Note: As requested, styles previously in .dugouts-title and .signin-image
// are now applied inline using the 'sx' prop below.

export const SignIn = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        console.log("SignIn: Setting up auth listener...");
        const unregisterAuthObserver = auth.onAuthStateChanged(user => {
            console.log("SignIn: Auth state changed, user:", !!user);
            if (user) {
                console.log("SignIn: User found, redirecting to /teams/ ...");
                history.push('/teams/');
            } else {
                console.log("SignIn: No user found, displaying sign-in UI.");
                setIsLoading(false);
            }
        });
        return () => {
            console.log("SignIn: Cleaning up auth listener.");
            unregisterAuthObserver();
        };
    }, [history]);

    if (isLoading) {
        console.log("SignIn: Rendering Loading component.");
        return <Loading />;
    }

    console.log("SignIn: Rendering Animated Sign-In UI.");
    return (
        <AnimatedBox root staggerSpeed={'Slow'}
            sx={{
                backgroundColor: '#000000',
                height: '100vh',
                width: '100%',
                display: 'flex', // Using flex to help center PageContainerComponent
                flexDirection: 'column',
                alignItems: 'center', // Center horizontally
                justifyContent: 'center', // Center vertically (optional)
            }}
        >

            <AnimatedBox>
                <Box
                    component="img"
                    src="/images/logos/dndlogo.png" // Updated logo path
                    alt="Dugouts and Dragons Logo"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        // Styles previously in .signin-image
                        width: '50vmin', // Adjust size as needed
                        height: '50vmin',
                        //  flexGrow: 1,
                        flexShrink: 2
                    }}
                />
            </AnimatedBox>
            <AnimatedBox transition={{ duration: SpeedDurations.Slow, delay: 5 }}>
                <HelpTextComponent>Please sign in to manage your team</HelpTextComponent>
            </AnimatedBox>
            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
        </AnimatedBox>
    );
}